module.exports = __webpack_public_path__ + "assets/media/day37.ed356d67.mp3";